import { render, staticRenderFns } from "./IndoorsDataDetails copy.vue?vue&type=template&id=0f6a0e9e&scoped=true"
import script from "./IndoorsDataDetails copy.vue?vue&type=script&lang=js"
export * from "./IndoorsDataDetails copy.vue?vue&type=script&lang=js"
import style0 from "./IndoorsDataDetails copy.vue?vue&type=style&index=0&id=0f6a0e9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f6a0e9e",
  null
  
)

export default component.exports